import React from "react";
import { PowerDialerCall } from "@/context/PowerDialerContext";
import { StatusDot } from "@/components/dialer/components/StatusDot";
import { statusLabel } from "@/components/dialer/components/StatusLabel";
import { getContactDisplayName } from "@/util/string";

export function DialingCallItem({ call }: { call: PowerDialerCall }) {
  const isMachine = call.amdResult?.toLowerCase().startsWith("machine") ?? false;
  const meta = isMachine ? "Machine detected" : statusLabel(call.status);

  return (
    <div className="flex items-center gap-3 rounded-md px-1 py-2.5">
      <StatusDot status={call.status} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-base font-semibold dark:text-white">
          {getContactDisplayName(call.contact) ?? "Unknown"}
        </p>
        <p className="truncate text-sm text-muted-foreground">{meta}</p>
      </div>
    </div>
  );
}
